import React, { Fragment } from 'react';
import Header from '../headers/Header';
import Footer from '../footer/Footer';

const Users = () => {
  return (
    <Fragment>
      <Header type={"client"}/>
        <div>
          <h1>Customer users list</h1>
          <h2>Functionalities:</h2>
          <ul>
            <li>See one given customer users</li>
            <li>CRUD a user</li>
          </ul>
        </div>
      <Footer type="main"/>
    </Fragment>
  )
}

export default Users;
